import { Point } from "../classes/geometry";

export class DOMHelpers
{
    static removeChildren(element:HTMLElement):void {while (element.firstChild) {element.removeChild(element.firstChild);}}

     /**
     * Converts from page coordinates which are relative to client page (e.g. MouseEvent.pageX, MouseEvent.pageY) to
     * coordinates inside the element
     *
     * @param element
     * @param pageX
     * @param pageY
     */
    static pageToElement(element:HTMLElement, pageX: number, pageY:number):Point
    {
        let rect = element.getBoundingClientRect();
        let scrollX = window.pageXOffset;
        let scrollY = window.pageYOffset;
        return new Point(pageX - rect.left - scrollX, pageY - rect.top - scrollY);
    }
}